import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Dropdown } from 'antd';
import { UploadOutlined, PrinterOutlined, PlusOutlined, MinusOutlined} from '@ant-design/icons';
import { FormattedMessage  } from 'react-intl';
import '../App.css';

const ADD_DEVICE = "ADD_DEVICE";
const LOAD_DEVICES = "LOAD_DEVICES";

class AddRemoveDevice extends Component {
  constructor(props) {
    super(props);
    this.download = this.onImport.bind(this);

    this.fileUpload = React.createRef();
    this.showFileUpload = this.showFileUpload.bind(this);

    this.items = [
      {
        key: ADD_DEVICE,
        label: <FormattedMessage id="AddRemoveMenu.add_device"/>,
        icon: <PrinterOutlined/>,
      },
      {
        key: LOAD_DEVICES,
        label: <div>
        <FormattedMessage id="AddRemoveMenu.load_devices" />
        <input
          type="file"
          id="my_file"
          style={{ display: "none" }}
          ref={this.fileUpload}
          onChange={(e) => this.readFile(e)}
          onClick={(e) => {
            e.target.value = null;
          }}
        />
        </div>,
        icon: <UploadOutlined/>,
      },      
    ];
  }

readFile(e) {
  var parent = this;
  var input = e.target;
  var reader = new FileReader();
  reader.onload = () => {
      var devices = reader.result.split(';');
      parent.props.onLoadDevices(devices);
  };

  reader.readAsText(input.files[0]);
}

showFileUpload() {
  this.fileUpload.current.click();
}

onImport(e)
{
    if (e.key === ADD_DEVICE)
    {
      this.props.onAddDevice();
    }
    else if (e.key === LOAD_DEVICES)
    {
      this.showFileUpload();      
    }
    else
    {
        console.log('Unknown menu key', e);
    }
}
  
    render() {
      return (
            <div className = "range-picker">
                <Dropdown menu={{
                    onClick: (e) => {this.onImport(e)},
                    items: this.items,
                  }}>
                  <Button type="normal"><PlusOutlined/>
                  </Button>
                </Dropdown>
                &nbsp;
                <Button type="normal" disabled = {this.props.disableDelete} onClick={this.props.onRemove}>
                    <MinusOutlined/>
                </Button>
            </div>

    );
  }
}
AddRemoveDevice.propTypes = {
    onAddDevice: PropTypes.func.isRequired,
    onLoadDevices: PropTypes.func.isRequired,
    onRemove: PropTypes.func.isRequired,
    disableDelete: PropTypes.bool.isRequired
  };

export default AddRemoveDevice;